import { useEffect, useState } from "react"
import { DataTable } from "../../../components/data-table";
import { RetailerInvoicesGridCols } from "./data-grid-cols";
import { ApisService } from "../../../app/core/apis.service";
import { useNavigate, useParams } from "react-router-dom";
import { dataDecrypt, encrypt } from "../../../app/utility/encryption-helper";
import moment from "moment";
import { getMonthStartAndEndDates } from "../../../app/utility/monthStartEndDate";
import { RiMoneyRupeeCircleLine } from "react-icons/ri";
import { MdPendingActions } from "react-icons/md";
import { LiaFileInvoiceSolid } from "react-icons/lia";

export const RetailerInvoices = () => {
    const params = useParams();
    const navigate = useNavigate();
    const { startDate, endDate } = getMonthStartAndEndDates();
    const [inputValue, setInputValue] = useState("");
    const [loading, setLoading] = useState<boolean>(false);
    const [invoiceData, setInvoiceData] = useState<any>();
    const [fromDate, setFromDate] = useState<any>(startDate);
    const [toDate, setToDate] = useState<any>(endDate);
    const initialPayload = {buId:params.org, filter: { limit: 10, page: 0 , DateFrom: startDate, DateTo: endDate} }
    const [pageCount, setPageCount] = useState(initialPayload);

    useEffect(() => {
        getRetailInvoices(initialPayload);
    }, []);

    async function getRetailInvoices(data: any): Promise<void> {
        setLoading(true);
        try {
            let encrytedData = encrypt(JSON.stringify(data));
            const res = await ApisService.retailerApi("findInvoicesByBuId", encrytedData);
            const retailerInvoiceData = JSON.parse(dataDecrypt(res.data.data));
            const retailerData = retailerInvoiceData;
            retailerData.results.forEach((el: any) => {
                el.Date = moment(el.created_date).format("DD-MM-YYYY");
                el.name = el.buyer.name;
                el.contact = el.buyer.mobile_number;
            })
            setInvoiceData(retailerData);
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
        }
    }

    const handleChange = (e: any) => {
        let payload = { buId: params.org, filter: {limit:10,page:0, DateFrom: fromDate, DateTo: toDate, name: e.target.value } };
        getRetailInvoices(payload);
        setInputValue(e.target.value);
    }


    const handleClose = () => {
        setInputValue("");
        setFromDate(startDate);
        setToDate(endDate);
        getRetailInvoices(initialPayload);
    }

    const searchData = () => {
        let payload = { buId: params.org, filter: { limit:10,page:0,name: inputValue, DateFrom: fromDate, DateTo: toDate } };
        getRetailInvoices(payload);
    }

    const selectFromDate = (e: any) => {
        setFromDate(e.target.value);
    }

    const selectToDate = (e: any) => {
        setToDate(e.target.value)
    }

    const onSelectPaginator = (data: any) => {
        const pageData = { ...pageCount, page: data };
        let payload = {buId: params.org,filter: { limit: pageData.filter.limit,name: inputValue, page: data, DateFrom: fromDate, DateTo: toDate } }
        setPageCount(payload);
        getRetailInvoices(payload);
    };

    const onActions = (data: any) => {
         if(data?.type==="view"){
            navigate(`/dashboard/organizations/org-details/${params.org}/retailer/${data?.data?._id}/view`)
        }
     }

    return (
        <div>
            <div className="row ">
                <div className="col-12 px-0">
                    <h5 className="mt-3 mb-2 fw-bold">Retailer Invoices</h5>
                    <input type="text" className="form-control rounded-pill" value={inputValue} onChange={handleChange} placeholder="Search invoice by customer name" />
                    <div className="row mt-2">
                        <div className="col-md-5 mb-2">
                            <input type="date" className="form-control" value={fromDate} onChange={selectFromDate} />
                        </div>
                        <div className="col-md-5 mb-2">
                            <input type="date" className="form-control" value={toDate} min={fromDate} onChange={selectToDate} />
                        </div>
                        <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white" onClick={searchData}>Search</button></div>
                        <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white" onClick={handleClose}>Clear</button></div>
                    </div>
                    {loading && (
                        <div className="text-center p-5"><div className="spinner-border" role="status"><span className="sr-only"></span></div></div>
                    )}
                    {!loading && (
                        <div className="mt-3">
                            {/* <div className="row">
                                <div className="col-md-4 mb-2">
                                    <div className="card text-white border-0" style={{backgroundColor:"#1A73E8"}}>
                                        <div className="card-body py-1">
                                            <div className="d-flex justify-content-between align-items">
                                                <div className="lh-0-5">
                                                    <div className="fs-4">₹ {invoiceData?.invTotalAmount}</div>
                                                    <div className="fs-6">Total Invoice Amount</div>
                                                </div>
                                                <div><LiaFileInvoiceSolid   size={35}/></div> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                 <div className="col-md-4 mb-2">
                                    <div className="card text-white border-0" style={{backgroundColor:"#34A853"}}>
                                        <div className="card-body py-1">
                                            <div className="d-flex justify-content-between align-items">
                                                <div className="lh-0-5">
                                                    <div className="fs-4">₹ {invoiceData?.invoicePendingAmount }</div>
                                                    <div className="fs-6">Total Pending Amount</div>
                                                </div>
                                                <div><MdPendingActions size={35}/></div> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                 <div className="col-md-4">
                                    <div className="card text-white border-0" style={{backgroundColor:"#FBBC05"}}>
                                        <div className="card-body py-1">
                                            <div className="d-flex justify-content-between align-items">
                                                <div className="lh-0-5">
                                                    <div className="fs-4">₹ {invoiceData?.invoicePaidAmount }</div>
                                                    <div className="fs-6">Total Paid Amount</div>
                                                </div>
                                                <div><RiMoneyRupeeCircleLine size={35}/></div> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <DataTable
                                tableData={invoiceData}
                                TableCols={RetailerInvoicesGridCols}
                                pagination={true}
                                pageCount={pageCount}
                                onSelectPageChange={(e) => onSelectPaginator(e)}
                                onActions={(e) => onActions(e)}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}   